import React from 'react';
import { useDispatch } from 'react-redux';
import { Link } from 'react-router-dom';
import { Table, Button } from 'antd';
import { sortableContainer, sortableElement } from 'react-sortable-hoc';

import PageContent from '../../components/Layout/PageContent';
import {
  mobileCardsActiveColumns,
  mobileCardsOnQueueColumns,
  mobileCardsExpiredColumns,
  fixtureData,
} from './constants';
import './MobileCards.css';

const MobileCardsList = () => {
  const dispatch = useDispatch();

  const DraggableContainer = (props) => (
    <SortableContainer
      useDragHandle
      helperClass="row-dragging"
      onSortEnd={({ oldIndex, newIndex }) => console.log({ oldIndex, newIndex })}
      {...props}
    />
  );

  return (
    <PageContent title="Home" breadcrumb={['Mobile App', 'Home']} className="mobile-cards-list">
      <div className="mobile-cards-list__add_button">
        <Link to="/mobile/cards/create">
          <Button type="primary" size="large">CREATE NEW</Button>
        </Link>
      </div>
      <section className="mobile-cards-list__section">
        <h4>Active</h4>
        <Table
          columns={mobileCardsActiveColumns(dispatch)}
          dataSource={fixtureData}
          pagination={false}
          rowKey="id"
          components={{
            body: {
              wrapper: DraggableContainer,
              row: DraggableBodyRow(fixtureData),
            },
          }}
        />
      </section>
      <section className="mobile-cards-list__section">
        <h4>On Queue</h4>
        <Table
          columns={mobileCardsOnQueueColumns(dispatch)}
          dataSource={fixtureData}
          pagination={false}
          rowKey="id"
          components={{
            body: {
              wrapper: DraggableContainer,
              row: DraggableBodyRow(fixtureData),
            },
          }}
        />
      </section>
      <section className="mobile-cards-list__section">
        <h4>Expired</h4>
        <Table
          columns={mobileCardsExpiredColumns(dispatch)}
          dataSource={fixtureData}
          pagination={false}
          rowKey="id"
          components={{
            body: {
              wrapper: DraggableContainer,
              row: DraggableBodyRow(fixtureData),
            },
          }}
        />
      </section>
    </PageContent>
  );
};

export default MobileCardsList;

const DraggableBodyRow = (webCardsList) => ({ ...props }) => {
  const index = webCardsList.findIndex(({ id }) => `${id}` === `${props['data-row-key']}`);
  return <SortableItem index={index} {...props} />;
};

const SortableItem = sortableElement((props) => <tr {...props} />);
const SortableContainer = sortableContainer((props) => <tbody {...props} />);
